import { useTheme } from "@/contexts/ThemeContext";
import { Button } from "@/components/ui/button";
import { Icon } from "@/components/ui/icon";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export const ThemeToggle = () => {
  const { theme, setTheme, resolvedTheme } = useTheme();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className="size-9 rounded-full"
          aria-label="Toggle theme"
        >
          <Icon
            name={resolvedTheme === "dark" ? "dark_mode" : "light_mode"}
            size={20}
            className="text-muted-foreground hover:text-foreground transition-colors"
          />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={() => setTheme("light")}>
          <Icon name="light_mode" size={16} className="mr-2" />
          Light
          {theme === "light" && <Icon name="check" size={16} className="ml-auto" />}
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => setTheme("dark")}>
          <Icon name="dark_mode" size={16} className="mr-2" />
          Dark
          {theme === "dark" && <Icon name="check" size={16} className="ml-auto" />}
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => setTheme("system")}>
          <Icon name="computer" size={16} className="mr-2" />
          System
          {theme === "system" && <Icon name="check" size={16} className="ml-auto" />}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
